import React, { useEffect, useState } from 'react'

import getFormStatus from '@/Form/Functions/getFormStatus'

import request from '@function/ajax/request'

import { formatNum } from '@root/utility'

const { moment } = window;

export default function ProductRefDetails ({ product_ref, ...props })
{
	const [status, setStatus] = useState();
	const [product, setProduct] = useState();

	useEffect(function ()
	{
		const controller = new AbortController();

		if (!product_ref) return () => void 0;

		(async function ()
		{
			try
			{
				var { product } = await request('/fetch/product-ref-details')
				.config({ controller, keyword: 'ressource' })
				.post({ ref: product_ref });
			}
			catch (update)
			{
				if (controller?.signal?.aborted) return;

				return setStatus(update);
			}

			setProduct(product);
		})();

		return () => { controller.abort?.(); };
	},
	[product_ref]);

	if (status && !product)
	{
		return getFormStatus(status, ['v2']);
	}

	if (!product) return null;

	return (
		<table className="c-ref-details">

			<tr className="c-ref-details__fields is-header">

				<th className="c-ref-details__field-Ref">
					Référence
				</th>

				<th className="c-ref-details__field-PriceType">
					Type de prix
				</th>

				<th className="c-ref-details__field-Price">
					Prix
				</th>

				<th className="c-ref-details__field-ValidityStart">
					Début de validité
				</th>

				<th className="c-ref-details__field-ValidityEnd">
					Fin de validité
				</th>

				<th className="c-ref-details__field-LimitDate">
					Date limite
				</th>

			</tr>

			<tr className="c-ref-details__fields">

				<td className="c-ref-details__field-Ref">
					{ product.price.ref }
				</td>

				<td className="c-ref-details__field-PriceType">
					{ product.price.type }
				</td>

				<td className="c-ref-details__field-Price">
					{ formatNum(product.price.price, '0,0[.]00') } €
				</td>

				<td className="c-ref-details__field-ValidityStart">
					{
						product.price.validity_start
						? moment(product.price.validity_start).format('DD/MM/YYYY')
						: undefined
					}
				</td>

				<td className="c-ref-details__field-ValidityEnd">
					{
						product.price.validity_date
						? moment(product.price.validity_date).format('DD/MM/YYYY')
						: undefined
					}
				</td>

				<td className="c-ref-details__field-LimitDate">
					{
						product.price.limit_date
						? moment(product.price.limit_date).format('DD/MM/YYYY')
						: undefined
					}
				</td>

			</tr>

		</table>
	);
}